import "approot/global/providers/uikit.dialogs";
import "approot/global/providers/uikit.alerts";
import "webroot/static/src/common/js/polyfill_ie.js";
import "regenerator-runtime/runtime";

import { LoginDivaricationComponent } from "./login.divarication.component";
import { LoginService } from "./services/login.service";
import { LoginRepository } from "./login.repository";
import { LoginFormComponent } from "./loginform.component";
import { Select2Directive, Select2StackService, Select2Config } from "approot/global/ui-components/select2.directive";
import { SsoLoginComponent } from "./sso.login.component";
import { LoaderComponent } from "./loader.component";
import { LoginDataService } from "./services/login.data.service";
import { AccountsLoginComponent } from "./accounts.login.component";
import { AccountLoginComponent } from "./account.login.component";
import { LoginStrategiesService } from "./services/login.strategies.service";
import { PasswordRecoveryRepository, PasswordRecoveryService } from "./services/password.recovery.service";
import { NsModalDirective } from "approot/global/ui-components/nsModal";
import { LoginSelect2ConfigService } from "./services/login.select2.config.service";
import { PasswordRecoveryComponent } from "./password.recovery.component";
import { LoginCookiesService } from "./services/login.cookies.service";
import { LoginNoticeService } from "./services/login.notice.service";
import { SettingsRepository } from "approot/admin/serversettings/settings.repository";
import { ServAdminLoginComponent } from "./servadmin.login.component";
import { LogoutComponent } from "./logout.component";
import { SsoLoginErrorComponent } from "./sso.login.error.component";
import { SsoLoginErrorService } from "./services/sso.login.error.service";
import { LoginInitializer } from "./login.initializer";
import { MobileRepository } from "approot/mobile/mobile.repository";
import { ExternalChangePasswordComponent } from "./external/external.change.password.component";
import { ExternalChangePasswordRepository } from "./external/external.change.password.repository";
import { SsoChooseRoleService } from "./services/sso-choose-role.service";
import { SsoChooseRoleComponent } from "./sso-choose-role.component";
import { Metrika } from "approot/global/webapp/services/metrika.service";
import { AppContext } from "approot/global/services/context";
import { AddYaCounters } from "approot/global/metrika.initializer";
import { ChangeLanguageService } from "./services/changeLanguage.service";
import { LanguageChangeComponent } from "./changeLanguage.component";
import { ReportComponent } from "./report/report.component";

declare var angular: any;
declare var language: any;
declare var window: any;

const EnterDirective = () => {
	return (scope, element, attrs) => {
		element.on("keydown keypress", (event) => {
			if (event.which !== 13) {
				return;
			}

			scope.$evalAsync(() => scope.$eval(attrs.ngEnter));
			event.preventDefault();
		});
	};
}

const SlideToggleDirective = () => {
	return {
		restrict: "A",
		scope:{
			isOpen: "=ngSlideToggle"
		},
		link: (scope, element, attr) => {
			scope.$watch("isOpen", (newVal, oldVal) => {
				if(newVal !== oldVal) {
					element.slideToggle("fast");
				}
			});
		}
	}
}

/*@ngInject*/
// todo: не особо хорошо с директивами получилось, в разметке смотрится кривенько
const ClickOutsideDirective = ($document: ng.IDocumentService) => {
	return {
		restrict: "A",
		scope:{
			isOpen: "=ngClickOutside"
		},
		link: (scope, element, attr) => {
			$document.on("click", (event) => {
				let isClickedElement = element
					.find(event.target)
					.length > 0;

				if (isClickedElement) {
					return;
				}

				scope.isOpen = false;
				scope.$evalAsync();
			});
		}
	}
}

/*@ngInject*/
let config = ($routeProvider, $locationProvider: ng.ILocationProvider) => {
	$routeProvider
		.when("/authorize", LoginDivaricationComponent) // развилка
		.when("/login", LoginDivaricationComponent) // развилка
		.when("/logout", LogoutComponent)
		.when("/authorize/login", LoginFormComponent)
		.when("/authorize/login-pass", LoginFormComponent)
		.when("/authorize/salogin", ServAdminLoginComponent)
		.when("/authorize/accounts", AccountsLoginComponent)
		.when("/authorize/accountlogin", AccountLoginComponent)
		.when("/authorize/sso/:idp/login", SsoLoginComponent)
		.when("/authorize/sso/:idp/error", SsoLoginErrorComponent)
		.when("/authorize/sso/choose-role", SsoChooseRoleComponent)
		.when("/authorize/passrecovery", PasswordRecoveryComponent)
		.when("/authorize/external/recovery", ExternalChangePasswordComponent)
		.when("/authorize/report", ReportComponent)
		.otherwise({ redirectTo: "/authorize" });

	$locationProvider.hashPrefix('');
	$locationProvider.html5Mode({
		enabled: true,
		requireBase: true
	});
}

/*@ngInject*/
const run = ($http: ng.IHttpService, $rootScope, appContext: AppContext, metrika: Metrika, $q: ng.IQService, language: any) => {
	//обработка маршрутизации
	$rootScope.$on("$routeChangeStart",
		(event, next, prev) => {
			console.log("routeChangeStart", next, prev);
		});

	$http.defaults.headers.common["ver-front"] = appContext.version_frontend;

	new AddYaCounters(appContext, metrika, $q, language).execute();
}

angular.module("irtech.netcity.login", ["ngRoute", "ngCookies", "ui.bootstrap", "uikit.dialogs", "uikit.alerts"])
	.config(config)
	.directive('nsModal', NsModalDirective)
	.directive('ngEnter', EnterDirective)
	.directive('ngSlideToggle', SlideToggleDirective)
	.directive('ngClickOutside', ClickOutsideDirective)
	.directive(Select2Directive.selector, Select2Directive)
	.service("select2Stack", Select2StackService)
	.factory("language", () => language)
	.service("metrika", Metrika)
	.factory("appContext", () => {
		return LoginInitializer.appContext || window.appContext;
	})
	.value("select2Config", Select2Config)
	.service("loginService", LoginService)
	.service("loginDataService", LoginDataService)
	.service("loginStrategiesService", LoginStrategiesService)
	.service("select2ConfigService", LoginSelect2ConfigService)
	.service("passwordRecoveryService", PasswordRecoveryService)
	.service("passwordRecoveryRepository", PasswordRecoveryRepository)
	.service("loginRepository", LoginRepository)
	.service("loginCookiesService", LoginCookiesService)
	.service("loginNoticeService", LoginNoticeService)
	.service("settingsRepository", SettingsRepository)
	.service("ssoLoginErrorService", SsoLoginErrorService)
	.service("ssoChooseRoleService", SsoChooseRoleService)
	.service("mobileRepository", MobileRepository)
	.service("externalChangePasswordRepository", ExternalChangePasswordRepository)
	.service("changeLanguageService", ChangeLanguageService)
	.component(LanguageChangeComponent.selector, LanguageChangeComponent)
	.component("loginComponent", LoginDivaricationComponent)
	.component("loginFormComponent", LoginFormComponent)
	.component("loader", LoaderComponent)
	.run(run);

angular.module("appboostrap", []).service("loginInitializer", LoginInitializer);